import React, { useState } from 'react';
import './ContactForm.css';

interface FormData {
  name: string;
  appliance: string;
  description: string;
}

const ContactForm: React.FC = () => {
  const [formData, setFormData] = useState<FormData>({
    name: '',
    appliance: '',
    description: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const appliances = [
    'Cafeteira',
    'Liquidificador',
    'Aspirador de pó',
    'Ferro de passar',
    'Secador de cabelo',
    'Ventilador',
    'Micro-ondas',
    'Torradeira',
    'Batedeira',
    'Mixer',
    'Outro'
  ];

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };


  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Simular envio (aqui você integraria com sua API)
    setTimeout(() => {
      const whatsappMessage = encodeURIComponent(
        `Oi! Vim pelo site da Lar do Eletro e gostaria de saber mais sobre o orçamento:\n\n` +
        `Nome: ${formData.name}\n` +
        `Eletrodoméstico: ${formData.appliance}\n` +
        `Descrição: ${formData.description}`
      );
      
      const whatsappUrl = `https://wa.me/555132764130?text=${whatsappMessage}`;
      window.open(whatsappUrl, '_blank');
      
      setIsSubmitting(false);
      // Reset form
      setFormData({
        name: '',
        appliance: '',
        description: ''
      });
    }, 1000);
  };

  return (
    <section id="contact-form" className="contact-form section">
      <div className="container">
        <h2 className="section-title">Solicite seu Orçamento</h2>
        <p className="section-subtitle">
          Preencha o formulário abaixo para receber um orçamento personalizado
        </p>

        <div className="form-container">
          <form onSubmit={handleSubmit} className="contact-form-content">
            <div className="form-group">
              <label htmlFor="name">Nome Completo *</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                required
                placeholder="Seu nome completo"
              />
            </div>

            <div className="form-group">
              <label htmlFor="appliance">Eletrodoméstico *</label>
              <select
                id="appliance"
                name="appliance"
                value={formData.appliance}
                onChange={handleInputChange}
                required
              >
                <option value="">Selecione o eletrodoméstico</option>
                {appliances.map((appliance, index) => (
                  <option key={index} value={appliance}>
                    {appliance}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="description">Descrição do Problema *</label>
              <textarea
                id="description"
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                required
                rows={4}
                placeholder="Descreva o que está acontecendo com seu eletrodoméstico..."
              />
            </div>


            <button
              type="submit"
              className="btn btn-primary submit-btn"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Enviando...' : 'Solicitar Orçamento via WhatsApp'}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
